import axiosClient from './../../api/axiosClient';

export const chatsService = {
  async fetchChats(payload) {
    return await axiosClient.post('/api/conversations/chats', payload, {
      baseURL: process.env.REACT_APP_SOCKET_API_KEY,
    });
  },

  async fetchGroupChatById(chatId) {
    return await axiosClient.get(`/api/conversations/team-inbox/${chatId}`, {
      baseURL: process.env.REACT_APP_SOCKET_API_KEY,
    });
  },

  async fetchPairChatById(chatId) {
    return await axiosClient.get(`/api/conversations/pair-chats/${chatId}`, {
      baseURL: process.env.REACT_APP_SOCKET_API_KEY,
    });
  },
};
